export default __webpack_public_path__ + "static/media/covid.73e1b1a9.png";